import logo from "./logo.png";
import "./navbar.css";

const Navbar = () => {
   // window.addEventListener("scroll", () => {
   //    let nav = document.querySelector(".navContainer");
   //    nav?.classList.toggle("down", window.scrollY > 50);
   // });

   const handleClick = () => {
      let hamburger = document.querySelector(".hamburger");
      hamburger.classList.toggle("is-active");
   };

   return (
      <nav>
         <div className="container">
            <a className="logo" href="#">
               <img className="img-fluid" width={40} height={40} src={logo} alt="" />
               &nbsp; &nbsp;<h1>JOSUÉ MEDINA</h1>
            </a>

            <div className="menu">
               <a href="#">Home</a>
               <a href="#aboutme">About</a>
               <a href="#portfolio">Portfolio</a>
               <a href="#contact">Contact</a>
            </div>

            <button style={{ display: "none" }} onClick={handleClick} className="hamburger">
               <span></span>
               <span></span>
               <span></span>
            </button>
         </div>
      </nav>
   );
};

export default Navbar;
